// extracted by mini-css-extract-plugin
export default {"container":"cE-z","modal":"dE-z","dimensions":"eE-z","brandName":"fE-z","productName":"gE-z","labelValue":"hE-z","recipientEmail":"iE-z","recommendedFit":"jE-z","hiddenField":"kE-z"};